import React from 'react';

import { getIsIos } from '../getIsIos';
import { add, remove } from '../lockBody';

export const BODY_LOCK_DEFAULT_CLASS_NAMES = ['overscroll-none', 'overflow-hidden', 'touch-none'];

export const useBodyLock = (isOpen: boolean) => {
  React.useEffect(() => {
    if (!isOpen) {
      return;
    }

    const isIos = getIsIos();
    const { scrollY } = window;

    const bodyLockClassNames = [...BODY_LOCK_DEFAULT_CLASS_NAMES, ...(isIos ? ['fixed', 'inset-0'] : [])];

    // On iOS, there is an issue that allows scrolling content over the overlay even when the body has overflow hidden.
    // This addresses the issue described in https://centracommerce.atlassian.net/browse/WS-4381
    if (isIos) {
      document.body.style.setProperty('top', `-${scrollY}px`);
    }

    add(document.body, bodyLockClassNames);

    return () => {
      remove(document.body, bodyLockClassNames);

      if (isIos) {
        document.body.style.removeProperty('top');
        window.scrollTo(0, scrollY);
      }
    };
  }, [isOpen]);
};
